import {
  getByIdDaysSelector,
  getByIdWorkoutSelect
} from '@gymaholic/packages'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import { getWorkoutsDayUtil } from 'modules/day/utils/getWorkouts/index.js'

export const getWorkoutsByIdDaySelector = id => (state) => {
  const day = getByIdDaysSelector(id)(state)
  const workoutPointers = getWorkoutsDayUtil(day)
  return workoutPointers.map(
    workoutPointer => getByIdWorkoutSelect(getIdReduxUtil(workoutPointer))(state)
  )
}
